import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { RouteAction } from '@core/action/action';
import { TipoEntidadesEnvolvidasEnum } from '@core/models/mudanca-societaria';
import { EntidadesService } from '@core/services/entidades.service';
import { GrupoEconomicoService } from '@core/services/grupoeconomico.service';
import { MessageService } from '@core/services/message.service';
import { MovimentacaoSocietariaService } from '@core/services/movimentacao-societaria.service';
import { StatusEntidadeService } from '@core/services/status.entidade.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-entidade-envolvida-form',
  templateUrl: './entidade-envolvida-form.component.html',
  styleUrls: ['./entidade-envolvida-form.component.scss']
})
export class EntidadeEnvolvidaFormComponent implements OnInit, OnChanges {

  @Input() entidadeEnvolvida!: any;
  @Input() tipoEntidadesEnvolvidasSelecionada!: TipoEntidadesEnvolvidasEnum;
  @Input() tipoMudancaSelecionado: any;
  @Input() variasEntidades: boolean = false;
  @Output() tipoEntidadesEnvolvidasSelecionadaChange = new EventEmitter<any>();
  @Input() idEntidade!: any;
  @Input() entidade!: any;

  entidadeEnvolvidaForm!: FormGroup;

  entidadeParticipanteLista: any[] = [];
  statusEntidadeList: any[] = [];
  tipoEnvolvimentoLista: any[] = [];
  entidadeSofreuMudancaLista: any[] = [];
  entidadesLista: any[] = [];
  entidadeGruposLista: any[] = [];
  gruposEconomico: any[] = [];
  visualizar: boolean = false;
  acao!: RouteAction;
  acaoEnum = RouteAction;
  editar: boolean = false;
  inserir: boolean = false;
  mostrarRazaoSocial: boolean = false;

  tipoEntidadesEnvolvidasEnum = TipoEntidadesEnvolvidasEnum;
  requiredFields: string[] = [];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,

    private service: MovimentacaoSocietariaService,
    private entidadesService: EntidadesService,
    private grupoEconomicoService: GrupoEconomicoService,
    private statusEntidadeService: StatusEntidadeService,
    private messageService: MessageService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tipoMudancaSelecionado) {
      switch (this.tipoMudancaSelecionado?.id) {
        case TipoEnvolimentoEnum.AlteraçãoRazaoSocial:
          this.alteracaoRazaoSocialChange();
          this.mostrarRazaoSocial = true;
          break;

        case TipoEnvolimentoEnum.MudançaGrupoAcionario:
          this.mudancaGrupoAcionarioChange();
          break;

        default:
          this.mostrarRazaoSocial = false;
          break;
      }
    }


  }

  ngOnInit() {
    this.checkUrl();
    this.construirForm();
    this.carregarListas();
    this.dadosModal();

    if (this.entidadeEnvolvida) {
      this.entidadeEnvolvidaForm.patchValue(this.entidadeEnvolvida);
    }

    if (this.visualizar === undefined && this.editar === undefined && this.inserir === undefined ||
      this.visualizar === false && this.editar === false && this.inserir === false) {
      this.visualizar = true;
    }

    this.entidadeControl?.valueChanges.subscribe((value) => {
      if(value) {
        this.entidadeEnvolvidaForm.patchValue({ razaoSocialAnterior: value?.nomeRazaoSocial });
      }
    });
  }





  construirForm() {
    this.entidadeEnvolvidaForm = this.fb.group({
      entidade: [''],
      novaRazaoSocial: [''],
      razaoSocialAnterior: [{ value: '', disabled: true }], tipoEnvolvimento: [''],
      deveNotificar: [false],
      novoStatusEntidade: [''],
      emails: [[]],
      entidadeId: ['']

    })




    this.entidadeEnvolvidaForm.valueChanges.subscribe(() => {
      this.emitirAlteracaoFormulario();
    });

    if (this.variasEntidades) {
      this.variasEntidadesChange();
    }

    if (this.tipoEntidadesEnvolvidasSelecionada == TipoEntidadesEnvolvidasEnum.Unica) {
      this.unicaEntidadeChange();
    }


  }



  carregarListas() {
    forkJoin({
      entidadesLista: this.entidadesService.entidadeCombo(),
      tipoEnvolvimentoLista: this.service.tipoEnvolvimento(),
      gruposEconomico: this.grupoEconomicoService.listar(),
      statusEntidadeLista: this.statusEntidadeService.listar()
    }).subscribe((results) => {
      this.entidadesLista = results.entidadesLista;
      this.tipoEnvolvimentoLista = results.tipoEnvolvimentoLista;
      this.gruposEconomico = results.gruposEconomico.sort((a: { nomeGrupoEconomico: string; }, b: { nomeGrupoEconomico: any; }) => a.nomeGrupoEconomico.localeCompare(b.nomeGrupoEconomico));
      this.statusEntidadeList = results.statusEntidadeLista;
    });
  }

  checkUrl() {
    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.visualizar = this.acao == RouteAction.Visualizar;
      this.editar = this.acao == RouteAction.Editar;
      this.inserir = this.acao == RouteAction.Inserir;
    });
  }

  dadosModal() {
    if (this.idEntidade) {
      const entidadeSelecionada = this.entidadesLista.find(item => item.id === this.idEntidade);
      if (entidadeSelecionada) {
        this.entidadeEnvolvidaForm.patchValue({
          entidade: entidadeSelecionada
        });
      } else {
        console.warn(`Entidade com id ${this.idEntidade} não encontrada na lista.`);
      }
    }
  }

  emitirAlteracaoFormulario() {


    if (this.entidadeEnvolvidaForm.dirty) {
      const objEnvio = { ...this.entidadeEnvolvidaForm.getRawValue() };

      if (this.entidadeEnvolvida) {
        objEnvio.id = this.entidadeEnvolvida.id;
      } else {
        delete objEnvio.id;
      }

      if (objEnvio.entidade && typeof objEnvio.entidade === 'object' && objEnvio.entidade.id) {
        objEnvio.entidadeId = objEnvio.entidade.id;
      } else if (typeof objEnvio.entidade === 'number') {
        objEnvio.entidadeId = objEnvio.entidade;
      } else {
        objEnvio.entidadeId = null;
      }

      if (this.entidadeEnvolvida) {
        this.atualizarObjeto(this.entidadeEnvolvida, objEnvio);
      } else {
        this.entidadeEnvolvida = objEnvio;
      }

      if (this.entidadeEnvolvidaForm.valid) {

        this.tipoEntidadesEnvolvidasSelecionadaChange.emit(this.entidadeEnvolvida);
      }
    }
  }


  atualizarObjeto(objOriginal: { [x: string]: any; }, objNovo: { [x: string]: any; hasOwnProperty: (arg0: string) => any; }) {
    for (const chave in objNovo) {
      if (objNovo.hasOwnProperty(chave) && objOriginal[chave] !== objNovo[chave]) {
        objOriginal[chave] = objNovo[chave];
      }
    }
  }

  resetFormValidator(): void {
    if (!this.entidadeEnvolvidaForm) {
      return;
    }

    Object.keys(this.entidadeEnvolvidaForm.controls).forEach(key => {
      const control = this.entidadeEnvolvidaForm.get(key);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity({ emitEvent: false });
      }
    });

    this.entidadeEnvolvidaForm.reset();
  }

  variasEntidadesChange() {
    this.requiredFields = ['entidade', 'tipoEnvolvimento', 'novoStatusEntidade'];
    this.validatorsRequired(this.requiredFields);
  }

  unicaEntidadeChange() {
    this.requiredFields = ['entidade', 'novoStatusEntidade'];
    this.validatorsRequired(this.requiredFields);

    if(this.idEntidade) {
      this.entidadeControl?.setValue({ id: this.idEntidade });
      this.entidadeControl?.disable();
    }
  }

  alteracaoRazaoSocialChange() {
    this.requiredFields = ['entidade', 'novaRazaoSocial', 'novoStatusEntidade'];

    if (this.tipoEntidadesEnvolvidasSelecionada == TipoEntidadesEnvolvidasEnum.Unica) {
      this.validatorsRequired(this.requiredFields);
    }
  }

  mudancaGrupoAcionarioChange() {
    this.requiredFields = ['entidade', 'novoGrupoEconomico', 'novoStatusEntidade'];

    if (this.tipoEntidadesEnvolvidasSelecionada == TipoEntidadesEnvolvidasEnum.Unica) {
      this.validatorsRequired(this.requiredFields);
    }
  }

  validatorsRequired(requiredFields: string[]): void {
    if (!this.entidadeEnvolvidaForm) {
      this.resetFormValidator();
      return;
    }

    this.resetFormValidator();

    Object.keys(this.entidadeEnvolvidaForm.controls).forEach(key => {
      const control = this.entidadeEnvolvidaForm.get(key);
      if (control) {
        if (requiredFields.includes(key)) {
          control.setValidators(Validators.required);
        } else {
          control.clearValidators();
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    });
  }

  isRequired(item: string): boolean {
    return this.requiredFields.includes(item);
  }

  compareFn(a: any, b: any): any {

    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    else if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }

    else if (a && b?.nome) {
      return a === b.nome;
    }else  if (a && b) {
      return a.id === b.id;
    }

     if (a && b?.id ) {
      return a === b?.id ;
    }else if(a?.id && b)
      return a.id === b

    else {
      return a === b;
    }
  }

  get deveNotificar() {
    return this.entidadeEnvolvidaForm.get('deveNotificar')?.value;
  }

  get tipoEnvolvimentoControl() {
    return this.entidadeEnvolvidaForm.get('tipoEnvolvimento');
  }

  get entidadeControl() {
    return this.entidadeEnvolvidaForm.get('entidade');
  }

  get novaRazaoSocialControl() {
    return this.entidadeEnvolvidaForm.get('novaRazaoSocial');
  }
}

export enum TipoEnvolimentoEnum {
  AlteraçãoRazaoSocial = 8,
  MudançaGrupoAcionario = 10
}
